
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/outcomes/content-view/jst/outcomeCalculationMethodForm';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <div id=\"calculation_int_container\" \n            data-initial-value=\"";
  if (helper = helpers.calculation_int) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculation_int); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" \n            data-label=\"";
  if (helper = helpers.calculationIntLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculationIntLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" \n            data-calculation-int-description=\"";
  if (helper = helpers.calculationIntDescription) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculationIntDescription); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n          </div>\n        ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <label for=\"calculation_int\" id=\"calculation_int_label\">\n            ";
  if (helper = helpers.calculationIntLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculationIntLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n          </label>\n          <span id=\"calculation_int\">";
  if (helper = helpers.calculation_int) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculation_int); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n          <span class=\"outcomes-calculation-int-italics\">\n            ";
  if (helper = helpers.calculationIntDescription) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculationIntDescription); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n          </span>\n        ";
  return buffer;
  }

function program5(depth0,data) {
  
  
  return "8";
  }

function program7(depth0,data) {
  
  
  return "12";
  }

  buffer += "<div class=\"content-box border border-trbl border-round\">\n  <div class=\"grid-row\">\n    <div id=\"calculation_int_left_side\" style=\""
    + escapeExpression((helper = helpers.hiddenUnlessExists || (depth0 && depth0.hiddenUnlessExists),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.calculation_int), options) : helperMissing.call(depth0, "hiddenUnlessExists", (depth0 && depth0.calculation_int), options)))
    + "\"\n      class=\"col-xs-4 border border-r\">\n      <div>\n        ";
  stack1 = (helper = helpers.ifIncludes || (depth0 && depth0.ifIncludes),options={hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.writeStates), (depth0 && depth0.state), options) : helperMissing.call(depth0, "ifIncludes", (depth0 && depth0.writeStates), (depth0 && depth0.state), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n      <div>\n      </div>\n    </div>\n    <div id=\"calculation_int_example_container\" class=\"col-xs-";
  stack1 = (helper = helpers.ifExists || (depth0 && depth0.ifExists),options={hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.calculation_int), options) : helperMissing.call(depth0, "ifExists", (depth0 && depth0.calculation_int), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    </div>\n  </div>\n</div>\n\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  